<p-toast position="top-right">
    <!-- Same icon + text as the default toast; toasts carrying data.link open that page on click -->
    <ng-template #message let-message>
        <div class="toast-body" [class.toast-body--link]="message.data?.link" (click)="openToastLink(message)"
            (keydown.enter)="openToastLink(message)" [attr.role]="message.data?.link ? 'link' : null"
            [attr.tabindex]="message.data?.link ? 0 : null">
            @if (message.icon) {
            <span class="p-toast-message-icon pi" [class]="message.icon"></span>
            } @else {
            @switch (message.severity) {
            @case ('success') { <svg data-p-icon="check" class="p-toast-message-icon" aria-hidden="true"></svg> }
            @case ('error') { <svg data-p-icon="times-circle" class="p-toast-message-icon" aria-hidden="true"></svg> }
            @case ('warn') { <svg data-p-icon="exclamation-triangle" class="p-toast-message-icon" aria-hidden="true"></svg> }
            @default { <svg data-p-icon="info-circle" class="p-toast-message-icon" aria-hidden="true"></svg> }
            }
            }
            <div class="p-toast-message-text">
                <div class="p-toast-summary">{{ message.summary }}</div>
                <div class="p-toast-detail">{{ message.detail }}</div>
            </div>
        </div>
    </ng-template>
</p-toast>
<router-outlet />
